<template>
</template>

<script>
	const serverSrc='www.baidu.com';
	const token='12345678';
	const hasEnter=false;
	const userSite="";
	let organ_sysno="";
	let upper_sysno="";
	const admin={
		upperSysno:0,
		upperSysno2:1,
	}
	const adminSysno={
		adminOrgan:1,
		adminOrgan2:2,
	}
	const adminUsers=[
		{account:17749722244,name:'王心保'},
		{account:13917522507,name:'任辉'},
	]
	let organDetail={}
  export default
  {
  	adminSysno,
  	organDetail,
  	adminUsers,//
  	organ_sysno,//机构编号
  	upper_sysno,
    userSite,//用户地址
    token,//用户token身份
    serverSrc,//服务器地址
    hasEnter,//用户登录状态
    admin,
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/common/Global.vue